import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../lib/auth";
import { Loader2 } from "lucide-react";

export default function AdminLoginPage() {
  const { login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  const nav = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setBusy(true);
    const res = await login(email, password);
    setBusy(false);
    if (res.ok) nav("/admin");
    else setError(res.error || "Login failed");
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[hsl(var(--linen))] px-6">
      <form
        data-testid="admin-login-form"
        onSubmit={submit}
        className="w-full max-w-md border border-[hsl(var(--line))] bg-[hsl(var(--sand))] p-10 rounded-sm"
      >
        <div className="display text-3xl">Staff sign-in</div>
        <p className="text-sm text-[hsl(var(--ink-muted))] mt-2">For Sweet Embrace pastors and admins.</p>

        <div className="mt-8 space-y-5">
          <div>
            <label className="text-xs uppercase tracking-[0.22em] text-[hsl(var(--ink-muted))]">Email</label>
            <input
              data-testid="admin-login-email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="mt-2 w-full bg-[hsl(var(--linen))] border border-[hsl(var(--line))] px-4 py-3 rounded-sm focus:outline-none focus:border-[hsl(var(--terracotta))]"
            />
          </div>
          <div>
            <label className="text-xs uppercase tracking-[0.22em] text-[hsl(var(--ink-muted))]">Password</label>
            <input
              data-testid="admin-login-password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="mt-2 w-full bg-[hsl(var(--linen))] border border-[hsl(var(--line))] px-4 py-3 rounded-sm focus:outline-none focus:border-[hsl(var(--terracotta))]"
            />
          </div>
        </div>

        {error && (
          <div data-testid="admin-login-error" className="mt-5 text-sm text-[hsl(var(--destructive))]">{error}</div>
        )}

        <button
          type="submit"
          data-testid="admin-login-submit"
          disabled={busy}
          className="mt-8 lift inline-flex w-full items-center justify-center gap-2 px-6 py-3.5 rounded-sm bg-[hsl(var(--terracotta))] hover:bg-[hsl(var(--terracotta-deep))] text-[hsl(var(--linen))] text-sm tracking-wide disabled:opacity-60"
        >
          {busy && <Loader2 size={16} className="animate-spin" />}
          Sign in
        </button>
      </form>
    </div>
  );
}
